import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack, TextField,InputAdornment } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory,Link } from "react-router-dom";
import { Search, SentimentDissatisfied } from "@mui/icons-material";
import Products from "./Products";

const Header = ({ children, hasHiddenAuthButtons }) => {

  const history = useHistory();


  
  const logOut = ()=>{
   localStorage.clear();
   window.location.reload(); 
  }
  let isUserLogIn = null;
  let login;
  let register;
  let avatar;
  let logout;
  let username;
  isUserLogIn = localStorage.getItem("username");
  if(!isUserLogIn){
    login = <Button className="explore" variant="text">
    Login
  </Button>
    register = <Button className="explore " variant="contained">
    Register
  </Button>
  }
  else{
    logout = <Button className="explore" variant="text" onClick={()=>{logOut()}}>
    logout
  </Button>
  avatar = <Avatar alt={isUserLogIn} src="avatar.png"></Avatar>
  username = <p className="username-text">{isUserLogIn}</p>
  }

//   let desktopSearch = <TextField
//   className="search-desktop"
//   onChange={(e) => children.debounceSearch(e, children.debounceTimeout)} // it should be  onChange={(e) => debounceSearch(e, debounceTimeout)}
//   value={children.search}
//   size="small"
//   fullWidth
//   InputProps={{
//     endAdornment: (
//       <InputAdornment position="end">
//         <Search color="primary" />
//       </InputAdornment>
//     ),
//   }}
//   placeholder="Search for items/categories"
//   name="search"
// />

 // console.log(isUserLogIn);
  return (
    <Box className="header" sx={{marginBottom: 3}}>
      {/* {desktopSearch} */}
      <Box className="header-title" onClick={()=>{history.push("/")}}>
        <img src="logo_light.svg" alt="QKart-icon" ></img>
      </Box>
        {children}
        {!hasHiddenAuthButtons && (<Stack direction="row" spacing={2}>
          <Link to="/login">
        {login}
        </Link>
        <Link to ="/register">
        {register}
        </Link>
        {avatar}
        {username }
        {logout}
      </Stack>)}

      {hasHiddenAuthButtons && (<Button
        className="explore-button"
        startIcon={<ArrowBackIcon />}
        variant="text"
        onClick={() => {
          history.push("/", { from: "Header" });
        }}
      >
        Back to explore
      </Button>)}
    </Box>
  );
};

export default Header;
